import styled from 'styled-components';
import { s } from './NPL.styles';
import { ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface IExpectedDividendAnalysisProps {
  expectedDividendAnalysis: ReturnType<
    NplCalculation['getExpectedDividendAnalysis']
  >;
}

const ExpectedDividendAnalysis = (props: IExpectedDividendAnalysisProps) => {
  const { expectedDividendAnalysis } = props;
  return (
    <s.Div>
      <s.Title>예상 배당분석</s.Title>
      <div>
        <Table>
          <s.DivRow position="top">
            <s.LeftCell>(예상) 낙찰가격</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedDividendAnalysis.row1_1)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow>
            <s.LeftCell>선순위 합계금액</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedDividendAnalysis.row2_1)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow>
            <s.LeftCell>배당 준비액</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedDividendAnalysis.row3_1)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow>
            <s.LeftCell>채권최고액</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedDividendAnalysis.row1_2)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow>
            <s.LeftCell>(예상) 대출원리금 합계</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedDividendAnalysis.row2_2)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow backgroundColor="#F2F7FF">
            <s.LeftCell>
              대출채권 청구
              <br />
              (연체이자 포함) 가능금액
            </s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedDividendAnalysis.row3_2)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow backgroundColor="#F2F7FF" position="bottom">
            <s.LeftCell style={{ color: '#222222' }}>
              본건 (예상) 배당액
            </s.LeftCell>
            <s.RightCell style={{ color: '#008AFF', fontWeight: '700' }}>
              {ReportFormatNumber(expectedDividendAnalysis.row4)}
            </s.RightCell>
          </s.DivRow>
        </Table>
        <s.BlueSmallText>
          *선순위 내역과 예상 대출원리금 산정에 따라 배당액은 변동될 수 있음
        </s.BlueSmallText>
      </div>
    </s.Div>
  );
};

export default ExpectedDividendAnalysis;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;
